import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioRolesService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getRolesBySedes(codigo: string, sedes: string) {
    try {
      const request = await this.requestUrl.getFilterRequest(
        'rol/by-sedes',
        [ codigo, { 'sedes' : sedes }]
      );
      return request;
    } catch(e) {
      console.error(`ServicioRolesService.getRolesBySedes() : ${e}`);
    }

    return null;
  }
}

export interface RolEntity {
  unco ?: number;
  descripcion ?: string;
}
